import { motion } from "framer-motion";
import { ArrowRight } from "lucide-react";
import { SERVICES } from "./data";
import { scrollToSection } from "@/lib/scrollTo";

const SectionHeading = ({ overline, title, accent, id }) => (
  <motion.div
    initial={{ opacity: 0, y: 40 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-80px" }}
    transition={{ duration: 0.8, ease: [0.33, 1, 0.68, 1] }}
    className="mb-16 max-w-3xl"
  >
    <p className="mb-4 flex items-center gap-3 font-mono-accent text-[11px] uppercase tracking-[0.35em] text-[#A07E1F]" data-testid={`${id}-overline`}>
      <span className="inline-block h-2 w-2 rotate-45 bg-[#D4AF37]" />
      {overline}
    </p>
    <h2 className="font-serif-display text-3xl font-medium leading-tight tracking-tight text-[#12294D] sm:text-4xl lg:text-5xl" data-testid={`${id}-heading`}>
      {title} <span className="italic text-[#A07E1F]">{accent}</span>
    </h2>
  </motion.div>
);

export const Services = () => (
  <section id="services" className="mx-auto max-w-7xl px-5 py-24 sm:px-8 sm:py-36" data-testid="services-section">
    <SectionHeading id="services" overline="How We Help" title="Six ways we move you" accent="closer to a First." />
    <div className="grid grid-cols-1 gap-6 sm:grid-cols-2 lg:grid-cols-3 lg:gap-8">
      {SERVICES.map((s, i) => (
        <motion.div
          key={s.title}
          initial={{ opacity: 0, y: 48 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true, margin: "-60px" }}
          transition={{ duration: 0.7, delay: (i % 3) * 0.12, ease: [0.33, 1, 0.68, 1] }}
          className="luxury-card group flex flex-col overflow-hidden rounded-xl"
          data-testid={`service-card-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
        >
          <div className="relative h-44 overflow-hidden sm:h-48">
            <img
              src={s.image}
              alt={s.title}
              loading="lazy"
              className="h-full w-full object-cover opacity-70 transition-transform duration-700 ease-out group-hover:scale-105"
            />
            <div className="absolute inset-0 bg-[linear-gradient(to_top,rgba(18,41,77,0.65),transparent_70%)]" />
            <span className="absolute left-4 top-4 rounded-full border border-[#D4AF37]/40 bg-white/85 px-3 py-1 font-mono-accent text-[9px] uppercase tracking-[0.22em] text-[#A07E1F] backdrop-blur-sm">
              {s.tag}
            </span>
          </div>
          <div className="flex flex-1 flex-col p-6 sm:p-7">
            <h3 className="font-serif-display text-2xl font-semibold text-[#12294D] transition-colors duration-300 group-hover:text-[#A07E1F]">
              {s.title}
            </h3>
            <p className="mt-2 flex-1 text-sm leading-relaxed text-[#46586F]">{s.desc}</p>
            <button
              onClick={() => scrollToSection("#quote")}
              data-testid={`service-cta-${s.title.toLowerCase().replace(/[^a-z]+/g, "-")}`}
              className="mt-6 flex items-center gap-2 self-start font-mono-accent text-[11px] font-bold uppercase tracking-[0.2em] text-[#A07E1F] transition-colors duration-300 hover:text-[#12294D]"
            >
              Get a Free Quote
              <ArrowRight size={14} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </div>
        </motion.div>
      ))}
    </div>
  </section>
);

export { SectionHeading };
